import * as TypVratky from 'mc/lib/api/gen/proxioapi/TypVratky';

const captions = {
    [TypVratky.POKLADNA]: 'Pokladna',
    [TypVratky.BANKA]: 'Banka',
};

export function getCaption(value) {
    return captions[value];
}
